export const AVATAR_NEW_WINDOW = 'avatar_newWindow'

export const IMAGE_MODAL = 'image_modal'

export const LINK_NEW_WINDOW = 'link_newWindow'

export const LINK_MODAL = 'link_modal'

export const MODEL_DETAIL = 'model_detail'

export const SWITCH = 'switch'

export const TAG = 'tag'

export const BADGE = 'badge'

